import { parse, isValid, format } from 'date-fns';
/**
 * Checks if a given input string looks like a date.
 * Supports formats like:
 * - MM/DD/YYYY or DD/MM/YYYY
 * - YYYY/MM/DD
 * - Month DD, YYYY (e.g., January 1, 2024)
 *
 * @param input The input string to test
 * @returns True if the input matches a date pattern, false otherwise
 */
export const isDateLike = (input: string): boolean => {
    const datePattern = /^(\d{1,2}[-\/]\d{1,2}[-\/]\d{2,4})|(\d{4}[-\/]\d{1,2}[-\/]\d{1,2})|([A-Za-z]+\s\d{1,2},\s\d{4})$/;
    return datePattern.test(input);
};
/**
 * Formats a date string into 'MM/dd/yyyy' format if possible.
 * Tries parsing the input date against multiple formats.
 *
 * @param inputDate The date string to format
 * @returns The formatted date string or null if invalid
 */
export const formatDateString = (inputDate: string): string | null => {
    const formats = [
        'MM/dd/yyyy',
        'dd/MM/yyyy',
        'yyyy/MM/dd',
        'yyyy-MM-dd',
        'dd-MM-yyyy',
        'MM-dd-yyyy',
        'MMMM dd, yyyy',
        'yyyy/MM/dd HH:mm',
        'MM/dd/yyyy HH:mm',
        'dd-MM-yyyy HH:mm',
    ];

    for (const formatStr of formats) {
        const parsedDate = parse(inputDate, formatStr, new Date());
        if (isValid(parsedDate)) {
            return format(parsedDate, 'MM/dd/yyyy');
        }
    }

    return null; // Return null if no valid date is found
};